import { ILocalStorageKey } from "shared/types";

export class LocalStorageService {
  // time to live can be passed in seconds
  static setItem(key: ILocalStorageKey, value: unknown, ttl?: number): void {
    let stringifiedValue: string;

    if (ttl) {
      const data = { value, ttl: Date.now() + ttl * 1000 };
      stringifiedValue = JSON.stringify(data);
    } else {
      stringifiedValue =
        typeof value === "string" ? value : JSON.stringify(value);
    }

    window.localStorage.setItem(key, stringifiedValue);
  }

  static getItem(key: ILocalStorageKey): any {
    const value = window.localStorage.getItem(key);

    // key is not in localStorage or value is empty
    if (!value) {
      return null;
    }

    try {
      // we save all items as strings
      const item = JSON.parse(value);

      // if ttl is set check if ttl has expired
      if (item.ttl) {
        if (Date.now() > item.ttl) {
          // remove token if ttl has expired
          localStorage.removeItem(key);
          return null;
        } else {
          return item.value;
        }
      }
      return item;
    } catch {
      // if we can't parse value, return raw value
      return value;
    }
  }

  static hasItem(key: ILocalStorageKey): boolean {
    return !!LocalStorageService.getItem(key);
  }

  static removeItem(key: ILocalStorageKey): void {
    window.localStorage.removeItem(key);
  }
}
